import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { Comment } from '../graphql';
import { OrganizationDetailsService } from 'ZalamoLibrary/src/lib/core/organizations/organization-details.service';
import { bufferTime, filter, startWith, tap } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AliveState } from 'ZalamoLibrary/src/lib/core/ActiveState';
import { UserDetailsService } from 'ZalamoLibrary/src/lib/zalamo/auth/user-details.service';

@Component({
    selector: 'lib-comments-list',
    templateUrl: './comments-list.component.html',
    styleUrls: ['./comments-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CommentsListComponent extends AliveState implements OnInit {
  @Input() comments: Array<Comment> = [];
  oldestVisibleCommentDate = new Subject<number>();
  isSolo$ = this.organizationDetailsService.isSolo().pipe(startWith(true));
  @Input() isSolo = false;
  @Input() lastSeen: number;
  @Output() updateLastSeen = new EventEmitter<Array<number>>();
  me;

  constructor(
    private organizationDetailsService: OrganizationDetailsService,
    private userDetailsService: UserDetailsService
  ) {
    super();
    this.me = String(userDetailsService.getUserId());
  }

  ngOnInit(): void {
    this.subscribeWhileAlive(
      this.oldestVisibleCommentDate.pipe(
        filter((commentDate) => commentDate > this.lastSeen),
        bufferTime(1000),
        filter((dates) => !!dates.length),
        tap((x) => this.updateLastSeen.next(x))
      )
    );
  }

  trackComment(i, comment: Comment) {
    return i;
  }
}
